import {Component} from '@angular/core';
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {NavigationService} from "../../services/navigation/navigation.service";
import {AuthService} from "../../services/mygreencountry/auth.service";
import {NavController} from "@ionic/angular";

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  showParentDashboard: boolean = false;
  showStudentDashboard: boolean = false;

  constructor(
    public myGcService: MyGreenCountry,
    private navigationService: NavigationService,
    private authService: AuthService,
    private navCtrl: NavController
  ) {

  }

  ngOnInit() {

    this.initDashboard();

    this.navigationService.backToParent$.subscribe((back) => {
      if (back) {
        this.initDashboard();
      }
    });

  }

  initDashboard () {
    this.showStudentDashboard = false;
    this.showParentDashboard = false;

    if(this.authService.isStudent()){

      this.showStudentDashboard = true;

    }else if(this.authService.isParent()){

      if(this.authService.getLoginRole() === 'parent') {
        this.showParentDashboard = true;
      }else{
        this.showStudentDashboard = true;
      }

    }else{

      //@TODO: fix navigation
      this.authService.logout();
      this.navCtrl.navigateRoot('/login');

    }

  }



  ionViewDidEnter(){

  }


}
